import { buildPaginatedRequest, PaginatedRequestParams, PaginatedResponse } from "../../../../common/pagination";
import { ReportResultDto, StatementReportItem } from "../../../reports/domain";
import { WalletRepo } from "../../data";
import { CreditDto, TopUpEligibleResultDto, TopupOnboardDto, WalletTransactionDto } from "../dtos";
import { TopupPartnerDto } from "../dtos";

export class WalletService {

    private readonly repository;

    constructor() {
        this.repository = new WalletRepo();
    }

    public search(req: PaginatedRequestParams): Promise<PaginatedResponse<WalletTransactionDto>> {
        return this.repository.search(req);
    }
    public getDetails(id: number): Promise<WalletTransactionDto> {
        return this.repository.getDetails(id);
    }

    public searchTopupPartners(query: string): Promise<PaginatedResponse<TopupPartnerDto>> {
        
        var request = buildPaginatedRequest({
            sort: { sortOrder: 1, sortField: 'partnerName', multiSortMeta: undefined },
            filters: {
                partnerName: {
                    operator: 'AND',
                    constraints: [
                        {
                            value: query,
                            matchMode: "contains",
                        },
                    ],
                }
            },
            size: 2500,
        });
        return this.repository.searchTopupPartners(request);
    }

    public checkEligible(req: CreditDto): Promise<TopUpEligibleResultDto> {
        return this.repository.checkEligible(req);
    }

    public requestTopup(req: CreditDto): Promise<TopUpEligibleResultDto> {
        return this.repository.requestTopup(req);
    }

    public confirmTopup(req: CreditDto): Promise<boolean> {
        return this.repository.confirmTopup(req);
    }
    public createOrUpdate(dto: TopupOnboardDto): Promise<boolean> {
        return this.repository.createOrUpdate(dto);
    }

    public getWalletInfo(scale: number): Promise<ReportResultDto<StatementReportItem>> {
        return this.repository.getWalletInfo(scale);
    }
}
